import { mode } from "@chakra-ui/theme-tools";

export const globalStyles = {
	styles: {
		global: (props: any) => ({
			body: {
				bg: mode("gray.200", "gray.800")(props),
				fontFamily: "Helvetica, sans-serif",
			},
			html: {
				fontFamily: "Helvetica, sans-serif",
				overflowY: "overlay",
			},
		}),
	},
};
